"use strict";

var debug = require("debug")("knack.formatter.formatters.phone");

// '99 9999 9999'
var phoneNumberFormatOneRegex = new RegExp(/(\d{2})(\d{4})(\d{4})/);

// '9999 999 999'
var phoneNumberFormatTwoRegex = new RegExp(/(\d{4})(\d{3})(\d{3})/);

// '+99 (0)999 999 99?99'
var phoneNumberFormatThreeRegex = new RegExp(/(\d{2})(\d{1})(\d{3})(\d{3})(\d{4})/);

// '999.999.9999'
var phoneNumberFormatFourRegex = new RegExp(/(\d{3})(\d{4})/);

// '(999) 999-9999'
var phoneNumberFormatFiveRegex = new RegExp(/(\d{3})(\d{4})/);

/**
 * @alias "formatters.phone"
 * @param {Object} value
 * @param {String} value.number
 * @param {String} value.full
 * @param {String} value.area
 * @param {String} [value.ext]
 * @param {Object} [format]
 * @param {String} [format.format] See documentation for specific formats
 * @param {Boolean} [format.extension] Whether to include `value.ext`
 * @param {String} responseFormat
 * @param {Object} [options]
 * @param {String} [options.mode]
 * @return {String}
 */
var phoneFormatter = function phoneFormatter(value, format, responseFormat, options) {
  format = format || {
    format: "(999) 999-9999"
  };
  var phone = "";
  if (!value) {
    return "";
  }
  switch (format.format) {
    case "99 9999 9999":
      if (value.number) {
        phone += value.full.replace(phoneNumberFormatOneRegex, "$1 $2 $3");
      }
      break;
    case "9999 999 999":
      if (value.number) {
        phone += value.full.replace(phoneNumberFormatTwoRegex, "$1 $2 $3");
      }
      break;
    case "+99 (0)999 999 99?99":
      if (value.number) {
        phone += "+".concat(value.full.replace(phoneNumberFormatThreeRegex, "$1 ($2)$3 $4 $5"));
      }
      break;
    case "999.999.9999":
      if (value.area) {
        phone += "".concat(value.area, ".");
      }
      if (value.number) {
        phone += value.number.replace(phoneNumberFormatFourRegex, "$1.$2");
      }
      break;
    case "(999) 999-9999":
      if (value.area) {
        phone += "(".concat(value.area, ") ");
      }
      if (value.number) {
        phone += value.number.replace(phoneNumberFormatFiveRegex, "$1-$2");
      }
      break;
    default:
      // The default format is (999) 999-9999 which use `area` + `number` while this uses `full`
      // Ehh, arguably this is fine I guess
      phone = value.full;
      break;
  }
  if (format.extension && value.ext) {
    phone += " x".concat(value.ext);
  }
  if (responseFormat === "html" && options.mode === "renderer") {
    phone = "<a href=\"tel:".concat(value.full, "\">").concat(phone, "</a>");
  }
  return phone;
};
module.exports = phoneFormatter;